import { Injectable } from '@angular/core';

import {
  ConceptTopicItem,
  QueryTopicItem,
  SemantriaConfiguration,
  SemantriaConfigurationDto,
} from 'app/providers/semantria-api/configuration.service';
import { EnableClassTelemetry } from 'app/services/otel.service';
import { SemantriaAPIService } from '../semantria-api.service';

export interface IndustryPack extends SemantriaConfiguration {
  isIndustryPack: boolean;
}

@EnableClassTelemetry()
@Injectable()
export class IndustryPackService extends SemantriaAPIService {
  getIndustryPacks(): Promise<IndustryPack[]> {
    return this.get<IndustryPack[]>('/industry-packs/');
  }

  getIndustryPack(configId: string): Promise<IndustryPack> {
    return this.get<IndustryPack>(`/industry-packs/${configId}`);
  }

  getConfigurationItemCounts(configId: string) {
    return this.get(`/industry-packs/${configId}/info/`);
  }

  exportIndustryPack(configId: string): Promise<SemantriaConfigurationDto> {
    return this.get(`/industry-packs/${configId}/export/`);
  }

  getConceptTopic(configId: string, topicId: string): Promise<ConceptTopicItem> {
    return this.get(`/industry-packs/${configId}/concept-topics/${topicId}`);
  }

  getQueryTopic(configId: string, topicId: string): Promise<QueryTopicItem> {
    return this.get(`/industry-packs/${configId}/query-topics/${topicId}`);
  }
}
